import React, { useEffect, useLayoutEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { PageNotFound } from '../../common/PageNotFound';
import { usePropertiesDashboardViewModel } from '../models/PropertyDashboardViewModel';
import { usePropertiesDetailViewModel } from '../models/PropertyDetailViewModel';
import { PropertyDashboardPage } from '../views/PropertyDashboardPage';
import { PropertyDetailPage } from '../views/PropertyDetailPage';

type PropertyControllerProps = {
  page: 'dashboard' | 'detail';
};

export const PropertyController: React.FC<PropertyControllerProps> = ({ page = 'dashboard' }) => {
  const detailViewModel = usePropertiesDetailViewModel();
  const dashboardViewModel = usePropertiesDashboardViewModel();
  const { pathname, hash, key } = useLocation();
  const { slug = '' } = useParams();

  const init = async () => {
    switch (page) {
      case 'detail': {
        detailViewModel.init(slug);
        break;
      }
      case 'dashboard':
        dashboardViewModel.init();
        break;
    }
  };

  // prefetch data
  useEffect(() => {
    init();
  }, [page]);

  // auto scroll to hash
  useLayoutEffect(() => {
    const element = document.getElementById(hash.replace('#', ''));
    if (!element) return;
    setTimeout(() => element?.scrollIntoView({ behavior: 'smooth' }), 100);
  }, [pathname, hash, key, page]); // do this on route change

  switch (page) {
    case 'dashboard':
      return <PropertyDashboardPage />;
    case 'detail':
      return <PropertyDetailPage />;
    default:
      return <PageNotFound />;
  }
};
